module.exports = __webpack_public_path__ + "static/media/ca2-logo.4d4dd5db.png";